"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var CacheStoreType_1 = __importDefault(require("../../enums/CacheStoreType"));
var utilities_1 = require("@ikea-aoa/utilities");
/**
 * This class is used for storing and loading stores from cache.
 */
var StoreCache = /** @class */ (function () {
    /**
     * Constructor.
     *
     * @param locale Locale.
     * @param cache Cache store.
     */
    function StoreCache(locale, cache) {
        this.locale = null;
        this.cache = null;
        this.locale = locale;
        this.cache = cache || new utilities_1.GlobalCacheStore();
    }
    /**
     * Returns stores.
     *
     * @returns Stores.
     */
    StoreCache.prototype.getStores = function () {
        return this.cache.getStore(CacheStoreType_1.default.store).get(this.getCacheKey()) || null;
    };
    /**
     * Sets stores.
     *
     * @param stores Stores.
     */
    StoreCache.prototype.addStores = function (stores) {
        this.cache.getStore(CacheStoreType_1.default.store).set(this.getCacheKey(), stores);
    };
    /**
     * Removes stores.
     */
    StoreCache.prototype.clear = function () {
        this.cache.getStore(CacheStoreType_1.default.store).delete(this.getCacheKey());
    };
    /**
     * Returns cache key.
     *
     * @returns Cache key.
     */
    StoreCache.prototype.getCacheKey = function () {
        return this.locale + 'stores';
    };
    return StoreCache;
}());
exports.default = StoreCache;
//# sourceMappingURL=StoreCache.js.map